import { render, staticRenderFns } from "./KnInactiveItemsTable.vue?vue&type=template&id=4e52d2d6"
import script from "./KnInactiveItemsTable.vue?vue&type=script&lang=js"
export * from "./KnInactiveItemsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports